import { genericCRUDService } from '../../helpers/api';

export const SERVICE_URI = '/mobile';
export const BASE_URI = '/api/v1/mobile-orders';

export const { create } = genericCRUDService(SERVICE_URI, BASE_URI);
